import { LEADERBOARD_FETCH_CHUNK } from "#/shared/constants"

import createDappAsyncThunk from "../asyncThunk"
import {
  setCurrentUserLeaderboard,
  setLeaderboard,
  setLeaderboardFullyFetched,
} from "../slices/leaderboard"
import { setMatsnetLeaderboard } from "../slices/matsnet"

export const fetchUserLeaderboardRank = createDappAsyncThunk(
  "leaderboard/fetchUserLeaderboardRank",
  async (_, { dispatch, extra: { sdk } }) => {
    const currentUser = await sdk.mezo.api.leaderboard.getUserLeaderboardRank()

    dispatch(setCurrentUserLeaderboard(currentUser))

    return { rank: currentUser.rank, mats: currentUser.score }
  },
)

export const fetchLeaderboard = createDappAsyncThunk(
  "leaderboard/fetchLeaderboard",
  async (
    { start, end }: { start: number; end: number },
    { getState, dispatch, extra: { sdk } },
  ) => {
    const { leaderboard: currentLeaderboard } =
      getState().leaderboard.fullLeaderboard

    const { leaderboard: leaderboardChunk, users } =
      await sdk.mezo.api.leaderboard.getLeaderboard(start, end)

    // Let's check if there is more entries in the database by checking following
    // chunk of leaderboard data
    const { leaderboard: nextLeaderboardChunk } =
      await sdk.mezo.api.leaderboard.getLeaderboard(
        end,
        end + LEADERBOARD_FETCH_CHUNK,
      )

    const offset = end - start

    if (start === 0 && currentLeaderboard.length > 0) {
      return false
    }

    if (leaderboardChunk.length === 0) {
      return true
    }

    const fullLeaderboard = [
      ...currentLeaderboard,
      ...leaderboardChunk,
      ...(leaderboardChunk.length < offset ? nextLeaderboardChunk : []),
    ]

    dispatch(setLeaderboard({ leaderboard: fullLeaderboard, users }))
    dispatch(setLeaderboardFullyFetched(nextLeaderboardChunk.length === 0))

    return leaderboardChunk.length < offset
  },
)

export const refreshLeaderboard = createDappAsyncThunk(
  "leaderboard/refreshLeaderboard",
  async (_, { getState, dispatch, extra: { sdk } }) => {
    const { fullLeaderboard } = getState().leaderboard

    const { leaderboard, users } =
      await sdk.mezo.api.leaderboard.getLeaderboard(
        0,
        fullLeaderboard.leaderboard.length,
      )

    const { leaderboard: matsnetLeaderboard } =
      await sdk.mezo.api.matsnet.getMatsnetLeaderboard(
        0,
        fullLeaderboard.leaderboard.length,
      )

    dispatch(setLeaderboard({ leaderboard, users }))
    dispatch(setMatsnetLeaderboard(matsnetLeaderboard))
  },
)
